/** Tras AD en `/ad-redirect`, redirigir a epago-backoffice v2 si el login empezó ahí. */
export const AD_RETURN_KEY = 'epago_ad_return';
export const AD_RETURN_V2 = 'v2';
export const AD_RETURN_V2_HOME = '/v2/inicio';

export function consumeAdReturnToV2(): boolean {
    const value = sessionStorage.getItem(AD_RETURN_KEY);
    sessionStorage.removeItem(AD_RETURN_KEY);
    return value === AD_RETURN_V2;
}

export function clearAdReturnFlag(): void {
    sessionStorage.removeItem(AD_RETURN_KEY);
}
